import { ChangeDetectorRef, Component, ComponentFactoryResolver, HostListener, OnChanges, OnInit, SimpleChanges, ViewContainerRef, ViewEncapsulation } from "@angular/core";
import { formatNumber } from '@angular/common';
import { SharedService, round, roundUp, large } from '../../shared';
import { TherapieTabsEnum, ITitrationLogParams, TitrationEventType, D_THCKonzentrationStartInput, D_KolbenpipetteValue, D_DosierpumpeValue } from '../titration-rechner.model';


import { TitrationTherapieCommonComponent, DE } from '../therapie-common.component';

import * as d3 from "d3";
import { PartnerNamesEnum } from "../../medizinisches-cannabisantrag";
import { retry } from "rxjs";

@Component({
    selector: 'app-titration-therapie-starten',
    templateUrl: "./therapie-starten.component.html",
    styleUrls: ["./therapie-starten.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class TitrationTherapieStartenComponent extends TitrationTherapieCommonComponent implements OnInit, OnChanges {
    ActiveTherapieTab = TherapieTabsEnum.STARTEN;

    maximaleTageDosisTHCInput: any = 20;
    startTageDosisInput: any = 2.50;
    tageTitrierungInput: any = 2;
    steigerungDosisInput: any = 2.50;

    oneStufeBis = 2;
    twoStufeBis = 5;
    threeStufeBis = 7;

    maximaleTageDosisTHCList: any[] = [
        { text: '2,5 mg/Tag', mg: 2.5 },
        { text: '5 mg/Tag', mg: 5 },
        { text: '7,5 mg/Tag', mg: 7.5 },
        { text: '10 mg/Tag', mg: 10 },
        { text: '12,5 mg/Tag', mg: 12.5 },
        { text: '15 mg/Tag', mg: 15 },
        { text: '17,5 mg/Tag', mg: 17.5 },
        { text: '20 mg/Tag', mg: 20 },
        { text: '25 mg/Tag', mg: 25 },
        { text: '30 mg/Tag', mg: 30 },
        { text: '35 mg/Tag', mg: 35 },
        { text: '40 mg/Tag', mg: 40 },
        { text: '45 mg/Tag', mg: 45 },
        { text: '50 mg/Tag', mg: 50 }
    ];
    startTageDosisList: any[] = [
        { text: 'Niedrig (ca. 1,25 mg)', milligram: 1.25 },
        { text: 'Normal (ca. 2,5 mg)', milligram: 2.50 },
        { text: 'Hoch (ca. 5 mg)', milligram: 5.00 }
    ];
    tageTitrierungList: any[] = [
        { text: 'Tägliche Steigerung', tage: 1 },
        { text: 'Steigerung alle 2 Tage', tage: 2 },
        { text: 'Steigerung alle 3 Tage', tage: 3 },
        { text: 'Steigerung alle 4 Tage', tage: 4 }
    ];
    steigerungDosisList: any[] = [
        { text: 'Sehr niedrig (ca. 0,75 mg)', milligram: 0.75 },
        { text: 'Niedrig (ca. 1,25 mg)', milligram: 1.25 },
        { text: 'Normal (ca. 2,5 mg)', milligram: 2.50 },
        { text: 'Hoch (ca. 4 mg)', milligram: 4.00 },
        { text: 'Sehr hoch (ca. 5 mg)', milligram: 5.00 }
    ];

    totalTage: number = 30;
    werteFurDiagrammList: any[] = [];

    presetButtonsList: any[] = [
        { title: 'Balance', value: 'BALANCE' },
        { title: 'Standard', value: 'STANDARD' },
        { title: 'Nachts', value: 'NACHTS' }
    ];
    selectedPresetButton: any = null;


    get morgensPer() {
        var per = round((this.morgensVal / this.totalDosierungsVal) * 100, 2) || 0;
        return per;
    }
    get morgensPerDisplay() {
        return round(this.morgensPer);
    }

    get mittagsPer() {
        return round((this.mittagsVal / this.totalDosierungsVal) * 100, 2) || 0;
    }
    get mittagsPerDisplay() {
        return round(this.mittagsPer);
    }

    get abendsPer() {
        return round((this.abendsVal / this.totalDosierungsVal) * 100, 2) || 0;
    }
    get abendsPerDisplay() {
        return round(this.abendsPer);
    }

    get zurNachtPer() {
        return round((this.zurNachtVal / this.totalDosierungsVal) * 100, 2) || 0;

    }
    get zurNachtPerDisplay() {
        return round(this.zurNachtPer);
    }

    get dorierungType() {
        return this.artDerDorierungInput == this.KolbenpipetteValue ? 'Kolbenpipette in Millilitern' : 'Dosierpumpe in Hüben';
    }

    get maxDosierungsart() {
        return parseFloat(this.maximaleTageDosisTHCInput);
    }

    get artDDorierungInput() {
        return parseFloat(this.artDerDorierungInput);
    }

    get anwendungenProTagVal() {
        var total = 0;
        if (this.morgensVal > 0) {
            total += 1;
        }
        if (this.mittagsVal > 0) {
            total += 1;
        }
        if (this.abendsVal > 0) {
            total += 1;
        }
        if (this.zurNachtVal > 0) {
            total += 1;
        }
        return total;
    }

    get zeitlichesWirkungsprofil() {
        var obj: any = {
            morgensVal: this.morgensVal + 0.000001,
            mittagsVal: this.mittagsVal - 0.00001,
            abendsVal: this.abendsVal + 0.0002,
            zurNachtVal: this.zurNachtVal - 0.0000001
        }
        obj.morgensVal = obj.morgensVal < 0 ? 0 : obj.morgensVal;
        obj.mittagsVal = obj.mittagsVal < 0 ? 0 : obj.mittagsVal;
        obj.abendsVal = obj.abendsVal < 0 ? 0 : obj.abendsVal;
        obj.zurNachtVal = obj.zurNachtVal < 0 ? 0 : obj.zurNachtVal;
        var total = obj.morgensVal + obj.mittagsVal + obj.abendsVal + obj.zurNachtVal;
        obj = {
            ...obj,
            morgensPer: (obj.morgensVal / total) * 100 || 0,
            morgensPerR: round((obj.morgensVal / total) * 100, 2) || 0,
            mittagsPer: (obj.mittagsVal / total) * 100 || 0,
            mittagsPerR: round((obj.mittagsVal / total) * 100, 2) || 0,
            abendsPer: (obj.abendsVal / total) * 100 || 0,
            abendsPerR: round((obj.abendsVal / total) * 100, 2) || 0,
            zurNachtPer: (obj.zurNachtVal / total) * 100 || 0,
            zurNachtPerR: round((obj.zurNachtVal / total) * 100, 2) || 0,
            total
        }
        return obj;
    }

    get zeitlicherSchwerpunkt() {
        var objWirk = this.zeitlichesWirkungsprofil;

        var an1MoVal = (this.morgensVal / objWirk.total) > 0.25 ? 1 : 0;
        var an1MiVal = (this.mittagsVal / objWirk.total) > 0.25 ? 1 : 0;
        var an1AbVal = (this.abendsVal / objWirk.total) > 0.25 ? 1 : 0;
        var an1ZNVal = (this.zurNachtVal / objWirk.total) > 0.25 ? 1 : 0;
        var an1Total = an1MoVal + an1MiVal + an1AbVal + an1ZNVal;

        var anwendungen = {
            one: {
                morgensVal: an1MoVal,
                morgensPer: ((an1MoVal / an1Total) * 100) || 0,
                morgensPerR: round((an1MoVal / an1Total) * 100) || 0,
                mittagsVal: an1MiVal,
                mittagsPer: ((an1MiVal / an1Total) * 100) || 0,
                mittagsPerR: round((an1MiVal / an1Total) * 100) || 0,
                abendsVal: an1AbVal,
                abendsPer: ((an1AbVal / an1Total) * 100) || 0,
                abendsPerR: round((an1AbVal / an1Total) * 100) || 0,
                zurNachtVal: an1ZNVal,
                zurNachtPer: ((an1ZNVal / an1Total) * 100) || 0,
                zurNachtPerR: round((an1ZNVal / an1Total) * 100) || 0,
            },
            two: {
                morgensVal: this.morgensVal,
                morgensPer: ((this.morgensVal / this.totalDosierungsVal) * 100) || 0,
                morgensPerR: round((this.morgensVal / this.totalDosierungsVal) * 100) || 0,
                mittagsVal: this.mittagsVal,
                mittagsPer: ((this.mittagsVal / this.totalDosierungsVal) * 100) || 0,
                mittagsPerR: round((this.mittagsVal / this.totalDosierungsVal) * 100) || 0,
                abendsVal: this.abendsVal,
                abendsPer: ((this.abendsVal / this.totalDosierungsVal) * 100) || 0,
                abendsPerR: round((this.abendsVal / this.totalDosierungsVal) * 100) || 0,
                zurNachtVal: this.zurNachtVal,
                zurNachtPer: ((this.zurNachtVal / this.totalDosierungsVal) * 100) || 0,
                zurNachtPerR: round((this.zurNachtVal / this.totalDosierungsVal) * 100) || 0,
            },
            three: {
                morgensVal: this.morgensVal,
                morgensPer: ((this.morgensVal / this.totalDosierungsVal) * 100) || 0,
                morgensPerR: round((this.morgensVal / this.totalDosierungsVal) * 100) || 0,
                mittagsVal: this.mittagsVal,
                mittagsPer: ((this.mittagsVal / this.totalDosierungsVal) * 100) || 0,
                mittagsPerR: round((this.mittagsVal / this.totalDosierungsVal) * 100) || 0,
                abendsVal: this.abendsVal,
                abendsPer: ((this.abendsVal / this.totalDosierungsVal) * 100) || 0,
                abendsPerR: round((this.abendsVal / this.totalDosierungsVal) * 100) || 0,
                zurNachtVal: this.zurNachtVal,
                zurNachtPer: ((this.zurNachtVal / this.totalDosierungsVal) * 100) || 0,
                zurNachtPerR: round((this.zurNachtVal / this.totalDosierungsVal) * 100) || 0,
            },
            four: {
                morgensVal: this.morgensVal,
                morgensPer: ((this.morgensVal / this.totalDosierungsVal) * 100) || 0,
                morgensPerR: round((this.morgensVal / this.totalDosierungsVal) * 100) || 0,
                mittagsVal: this.mittagsVal,
                mittagsPer: ((this.mittagsVal / this.totalDosierungsVal) * 100) || 0,
                mittagsPerR: round((this.mittagsVal / this.totalDosierungsVal) * 100) || 0,
                abendsVal: this.abendsVal,
                abendsPer: ((this.abendsVal / this.totalDosierungsVal) * 100) || 0,
                abendsPerR: round((this.abendsVal / this.totalDosierungsVal) * 100) || 0,
                zurNachtVal: this.zurNachtVal,
                zurNachtPer: ((this.zurNachtVal / this.totalDosierungsVal) * 100) || 0,
                zurNachtPerR: round((this.zurNachtVal / this.totalDosierungsVal) * 100) || 0,
            }
        };

        var maxPer = Math.max(objWirk.morgensPer, objWirk.mittagsPer, objWirk.abendsPer, objWirk.zurNachtPer);
        var parsedData = [objWirk.morgensPer, objWirk.mittagsPer, objWirk.abendsPer, objWirk.zurNachtPer];
        var s1LargePer = large(parsedData, 2);
        var s2LargePer = large(parsedData, 3);
        var s3LargePer = large(parsedData, 4);

        var s1MoVal = (maxPer == s1LargePer) ? 0 : (objWirk.morgensPer == maxPer) ? 1 : 0;
        var s1MiVal = (maxPer == s1LargePer) ? 0 : (objWirk.mittagsPer == maxPer) ? 1 : 0;
        var s1AbVal = (objWirk.abendsPer == maxPer) ? 1 : 0;
        var s1ZUVal = (maxPer == s1LargePer) ? 0 : (objWirk.zurNachtPer == maxPer) ? 1 : 0;
        var s1Total = s1MoVal + s1MiVal + s1AbVal + s1ZUVal;

        var s2MoVal = (this.anwendungenProTagVal == 1) ? s1MoVal : (this.anwendungenProTagVal > 1) ? (objWirk.morgensPer > s2LargePer ? 1 * objWirk.morgensPer / 100 : 0) : 0;
        var s2MiVal = (this.anwendungenProTagVal == 1) ? s1MiVal : (this.anwendungenProTagVal > 1) ? (objWirk.mittagsPer > s2LargePer ? 1 * objWirk.mittagsPer / 100 : 0) : 0;
        var s2AbVal = (this.anwendungenProTagVal == 1) ? s1AbVal : (this.anwendungenProTagVal > 1) ? (objWirk.abendsPer > s2LargePer ? 1 * objWirk.abendsPer / 100 : 0) : 0;
        var s2ZUVal = (this.anwendungenProTagVal == 1) ? s1ZUVal : (this.anwendungenProTagVal > 1) ? (objWirk.zurNachtPer > s2LargePer ? 1 * objWirk.zurNachtPer / 100 : 0) : 0;
        var s2Total = s2MoVal + s2MiVal + s2AbVal + s2ZUVal;

        var s3MoVal = (this.anwendungenProTagVal == 1) ? s1MoVal : (this.anwendungenProTagVal == 2) ? s2MoVal : (this.anwendungenProTagVal > 2) ? (objWirk.morgensPer > s3LargePer ? 1 * objWirk.morgensPer / 100 : 0) : 0;
        var s3MiVal = (this.anwendungenProTagVal == 1) ? s1MiVal : (this.anwendungenProTagVal == 2) ? s2MiVal : (this.anwendungenProTagVal > 2) ? (objWirk.mittagsPer > s3LargePer ? 1 * objWirk.mittagsPer / 100 : 0) : 0;
        var s3AbVal = (this.anwendungenProTagVal == 1) ? s1AbVal : (this.anwendungenProTagVal == 2) ? s2AbVal : (this.anwendungenProTagVal > 2) ? (objWirk.abendsPer > s3LargePer ? 1 * objWirk.abendsPer / 100 : 0) : 0;
        var s3ZUVal = (this.anwendungenProTagVal == 1) ? s1ZUVal : (this.anwendungenProTagVal == 2) ? s2ZUVal : (this.anwendungenProTagVal > 2) ? (objWirk.zurNachtPer > s3LargePer ? 1 * objWirk.zurNachtPer / 100 : 0) : 0;
        var s3Total = s3MoVal + s3MiVal + s3AbVal + s3ZUVal;

        var stufe = {
            morgensVal: round(objWirk.morgensVal - round(objWirk.total / 4)),
            mittagsVal: round(objWirk.mittagsVal - round(objWirk.total / 4)),
            abendsVal: round(objWirk.abendsVal - round(objWirk.total / 4)),
            zurNachtVal: round(objWirk.zurNachtVal - round(objWirk.total / 4)),
            one: {
                morgensVal: round(s1MoVal, 2),
                morgensPer: ((s1MoVal / s1Total) * 100) || 0,
                morgensPerR: round((s1MoVal / s1Total) * 100) || 0,
                mittagsVal: round(s1MiVal, 2),
                mittagsPer: ((s1MiVal / s1Total) * 100) || 0,
                mittagsPerR: round((s1MiVal / s1Total) * 100) || 0,
                abendsVal: round(s1AbVal, 2),
                abendsPer: ((s1AbVal / s1Total) * 100) || 0,
                abendsPerR: round((s1AbVal / s1Total) * 100) || 0,
                zurNachtVal: round(s1ZUVal, 2),
                zurNachtPer: ((s1ZUVal / s1Total) * 100) || 0,
                zurNachtPerR: round((s1ZUVal / s1Total) * 100) || 0,
            },
            two: {
                morgensVal: round(s2MoVal, 2),
                morgensPer: ((s2MoVal / s2Total) * 100) || 0,
                morgensPerR: round((s2MoVal / s2Total) * 100) || 0,
                mittagsVal: round(s2MiVal, 2),
                mittagsPer: ((s2MiVal / s2Total) * 100) || 0,
                mittagsPerR: round((s2MiVal / s2Total) * 100) || 0,
                abendsVal: round(s2AbVal, 2),
                abendsPer: ((s2AbVal / s2Total) * 100) || 0,
                abendsPerR: round((s2AbVal / s2Total) * 100) || 0,
                zurNachtVal: round(s2ZUVal, 2),
                zurNachtPer: ((s2ZUVal / s2Total) * 100) || 0,
                zurNachtPerR: round((s2ZUVal / s2Total) * 100) || 0,
            },
            three: {
                morgensVal: round(s3MoVal, 2),
                morgensPer: ((s3MoVal / s3Total) * 100) || 0,
                morgensPerR: round((s3MoVal / s3Total) * 100) || 0,
                mittagsVal: round(s3MiVal, 2),
                mittagsPer: ((s3MiVal / s3Total) * 100) || 0,
                mittagsPerR: round((s3MiVal / s3Total) * 100) || 0,
                abendsVal: round(s3AbVal, 2),
                abendsPer: ((s3AbVal / s3Total) * 100) || 0,
                abendsPerR: round((s3AbVal / s3Total) * 100) || 0,
                zurNachtVal: round(s3ZUVal, 2),
                zurNachtPer: ((s3ZUVal / s3Total) * 100) || 0,
                zurNachtPerR: round((s3ZUVal / s3Total) * 100) || 0,
            },
            four: {
                morgensVal: this.morgensVal,
                morgensPer: ((this.morgensVal / this.totalDosierungsVal) * 100) || 0,
                morgensPerR: round((this.morgensVal / this.totalDosierungsVal) * 100) || 0,
                mittagsVal: this.mittagsVal,
                mittagsPer: ((this.mittagsVal / this.totalDosierungsVal) * 100) || 0,
                mittagsPerR: round((this.mittagsVal / this.totalDosierungsVal) * 100) || 0,
                abendsVal: this.abendsVal,
                abendsPer: ((this.abendsVal / this.totalDosierungsVal) * 100) || 0,
                abendsPerR: round((this.abendsVal / this.totalDosierungsVal) * 100) || 0,
                zurNachtVal: this.zurNachtVal,
                zurNachtPer: ((this.zurNachtVal / this.totalDosierungsVal) * 100) || 0,
                zurNachtPerR: round((this.zurNachtVal / this.totalDosierungsVal) * 100) || 0,
            }
        }

        var obj: any = { anwendungen, stufe }
        return obj;
    }

    constructor(protected cd: ChangeDetectorRef,
        protected vcr: ViewContainerRef,
        protected resolver: ComponentFactoryResolver,
        protected sharedService: SharedService) {
        super(cd, vcr, resolver, sharedService);
    }

    fnSetInputDefaultValues() {
        this.maximaleTageDosisTHCInput = 20;
        this.startTageDosisInput = 2.50;
        this.steigerungDosisInput = 2.50;
        this.tageTitrierungInput = 2;
    }

    fnSetDefaultValues() {
        this.fnSetCommonDefaultValues();
        this.fnSetInputDefaultValues();
    }

    ngOnInit(): void {
        this.fnSetDefaultValues();
        this.fnSetDefaultInputParams("ONLOAD");
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                let change = changes[propName];
                switch (propName) {
                    case 'productNameInput':
                        if (change.previousValue !== change.currentValue) {
                            this.productNameInput = change.currentValue;
                            if (this.productNameInput) {
                                if (change.previousValue) {
                                    this.fnSetDefaultInputParams("PRODUCT");
                                } else {
                                    this.fnSetDefaultInputParams("DEFAULT");
                                }
                            }
                        }
                        break;
                }
            }
        }
    }

    inputChangeProduct() {
        this._inputChangeProduct();
    }


    inputChange(Name: string, Value: any) {
        this.fnSaveTitrationLogParamChange(Name, Value);
        this.fnCalculateTablesAndGraphs();
    }

    sliderUserChange(Name: string, Value: any) {
        this.fnSaveTitrationLogParamChange(Name, Value);
        this.selectedPresetButton = null;
        this.fnCalculateTablesAndGraphs();
    }

    sliderValueChange() {

    }

    fnSaveTitrationLogParamChange(Name: string, Value: any) {
        let Params: ITitrationLogParams[] = [];
        Params.push({ Name, Value });
        this.saveTitrationLog(TitrationEventType.ParameterChange, Params);
    }

    onSelectPresetButton(button: any) {
        this.selectedPresetButton = button;
        this.fnSetCommonSliderValues(button.value);
        this.fnCalculateTablesAndGraphs();
    }


    onIconClick(type: any) {
        switch (type) {
            case 'info':
                this.fnShowRechnerInfoPopup();
                break;
            case 'reload':
                this.fnSetDefaultInputParams("RELOAD");
                break;
        }
    }

    fnSetDefaultInputBasedProduct() {
        if (this.partnerName == PartnerNamesEnum.DOSIS_EQ_TILRAY) {
            let removeDosierInd = this.artDerDorierungList.findIndex(a => a.value == D_DosierpumpeValue);
            if (removeDosierInd >= 0) {
                this.artDerDorierungList.splice(removeDosierInd, 1);
            }
        }
        if (this.productNameInput) {
            if (this.artDerDorierungList.findIndex(a => a.value == D_KolbenpipetteValue) >= 0) {
                this.artDerDorierungInput = D_KolbenpipetteValue;
            } else {
                this.artDerDorierungInput = this.artDerDorierungList[0].value;
            }
            let checkValue = 20;
            switch (this.partnerName) {
                case PartnerNamesEnum.DOSIS_EQ_TILRAY:
                    checkValue = 50;
                    break;
                case PartnerNamesEnum.DOSIS_EQ_HORMOSAN:
                case PartnerNamesEnum.DOSIS_EQ_420_PHARMA:
                    checkValue = 25;
                    break;
                default:
                    checkValue = 20;
                    break;
            }
            if (this.verschreibungsmengeList.findIndex(a => a.value == checkValue) >= 0) {
                this.verschreibungsmengeInput = checkValue;
            } else {
                this.verschreibungsmengeInput = this.verschreibungsmengeList[0].value;
            }
        } else {
            this.thcKonzentrationInput = D_THCKonzentrationStartInput;
            this.artDerDorierungInput = D_KolbenpipetteValue;
            this.verschreibungsmengeInput = 20;
        }
    }

    fnSetDefaultInputParams(type: 'DEFAULT' | 'ONLOAD' | 'RELOAD' | 'PRODUCT') {
        this.fnSetDefaultInputBasedProduct();
        this.fnSetInputDefaultValues();
        this.fnSetCommonSliderValues();

        this.selectedPresetButton = this.presetButtonsList[1];
        this.fnCalculateTablesAndGraphs();

        let Params = this.fnGetTitrationLogParams();
        if (type === 'PRODUCT') {
            this.generateTitrationLogParams(TitrationEventType.ProductSelection, Params);
        }
        else if (type === "ONLOAD" || type === "RELOAD") {
            let EventType = type === 'ONLOAD' ? TitrationEventType.PageLoad : TitrationEventType.PageReLoad;
            if (this.isShowPreLoadPopup) {
                this.fnShowPreLoadQuestionPopup(EventType, Params);
            } else {
                this.generateTitrationLogParams(EventType, Params);
            }
        }
    }

    fnGetTitrationLogParams() {
        let Params: ITitrationLogParams[] = [];
        Params.push({ Name: "Start Tagesdosis THC", Value: this.startTageDosisInput });
        Params.push({ Name: "Dosissteigerung Tage", Value: this.tageTitrierungInput });
        Params.push({ Name: "Steigerung THC", Value: this.steigerungDosisInput });
        Params.push({ Name: "Max. Tagesdosis THC", Value: this.maximaleTageDosisTHCInput });
        return Params;
    }

    fnShowRechnerInfoPopup(accNumber = null) {
        this.fnShowCommonRechnerInfoPopup(accNumber, TherapieTabsEnum.STARTEN);
    }

    fnPrintPageData() {
        let Params = this.fnGetTitrationLogParams();
        this.fnPrintData(Params);
    }

    fnShowRezeptPopup() {
        let Params = this.fnGetTitrationLogParams();
        this.fnShowCommonRezeptPopup(Params, this.getHeaderContent(false));
    }

    fnCalculateTablesAndGraphs() {
        switch (this.partnerName) {
            case PartnerNamesEnum.DOSIS_EQ_TILRAY:
                this.fnCalculateWerteFurDiagrammTilRay();
                break;
            default:
                this.fnCalculateWerteFurDiagramm();
                break;
        }
        this.fnGenerateChart();
    }

    getWrteFurForIndex(index) {
        return this.werteFurDiagrammList[index];
    }

    getHeaderContent(html = true) {
        if (html) {
            return this.generateHeaderContentProductHTML();
        } else {
            return this.generateHeaderContentProductRezept();
        }
    }

    generateHeaderContentProductRezept() {
        var first = this.getWrteFurForIndex(0);
        var content = ``;
        content += `${formatNumber(parseFloat(this.verschreibungsmengeInput), DE)} mL ${this.productArt} mit ${formatNumber(this.productTHC, DE)} mg THC/mL `;
        if (this.productCBD) {
            content += `und ${formatNumber(this.productCBD, DE)} mg CBD/mL `;
        }
        //content += `(${formatNumber(parseFloat(this.verschreibungsmengeInput) * this.productTHC, DE)} mg THC `;
        //if (this.productCBD) {
        //    content += `und ${formatNumber(parseFloat(this.verschreibungsmengeInput) * this.productCBD, DE)} mg CBD `;
        //}
        //content += `gesamt)`;
        content += `, `;
        content += `Startdosis 1 x `;
        if (this.artDerDorierungInput == this.KolbenpipetteValue) {
            content += `${formatNumber(first.summenML, DE)} mL, `;
        } else {
            content += `${formatNumber(first.dosierungsart, DE)} Hübe, `;
        }
        content += `Maximaldosis: `;
        var maxDosierungsart = parseFloat(this.maximaleTageDosisTHCInput);
        if (this.artDerDorierungInput == this.KolbenpipetteValue) {
            content += `${formatNumber(round(maxDosierungsart / this.productTHC, 2), DE)} mL/Tag, `;
        } else {
            content += `${formatNumber(round(maxDosierungsart / this.productTHC / this.DosierpumpeValue), DE)} Hübe/Tag, `;
        }
        content += `orale Einnahme >>Dj<<`;
        return content;
    }

    generateHeaderContentProductHTML() {
        var first = this.getWrteFurForIndex(0);
        var content = `<p>`;
        content = `${this.productArt}, orale Einnahme, Startdosis 1 x `;
        if (this.artDerDorierungInput == this.KolbenpipetteValue) {
            content += `${formatNumber(first.summenML, DE)} mL, `;
        } else {
            content += `${formatNumber(first.dosierungsart, DE)} Hübe, `;
        }
        content += `</p><p>`;
        content += `Steigerung der Tagesdosis alle ${this.tageTitrierungInput} Tage um `;
        if (this.artDerDorierungInput == this.KolbenpipetteValue) {
            content += `${formatNumber(round((this.steigerungDosisInput / this.productTHC) * (1 / this.DosierpumpeValue) / (1 / this.DosierpumpeValue), 3), DE)} mL/Tag `;
        } else {
            content += `${formatNumber(round((this.steigerungDosisInput / this.productTHC) * (1 / this.DosierpumpeValue)) / (1 / this.DosierpumpeValue) / this.DosierpumpeValue, DE)} Hübe/Tag `;
        }
        content += `verteilt auf bis zu 2 Einzeldosen,`;
        content += `</p><p>`;
        content += `Maximaldosis: `;
        var maxDosierungsart = parseFloat(this.maximaleTageDosisTHCInput);
        if (this.artDerDorierungInput == this.KolbenpipetteValue) {
            content += `${formatNumber(round(maxDosierungsart / this.productTHC, 2), DE)} mL/Tag`;
        } else {
            content += `${formatNumber(round(maxDosierungsart / this.productTHC / this.DosierpumpeValue), DE)} Hübe/Tag`;
        }
        content += `</p><p>`;
        content += `Verschreibungsmenge ausreichend für ${this.tageRezept} Tage`;
        content += `</p>`;
        return content;
    }

    fnCalculateWerteFurDiagramm() {
        this.werteFurDiagrammList = [];
        var summe = 0;
        for (var i = 1; i <= 200; i++) {
            var stufeDosis = 0;
            var maxDosierungsart = 0;
            var dosierungsart = 0;

            var summenML = 0;
            var unterMenge = "";

            var morgens = 0;
            var mittags = 0;
            var abends = 0;
            var zurnacht = 0;

            var morgensText = "";
            var mittagsText = "";
            var abendsText = "";
            var zurnachtText = "";
            var thcd: any = "";

            stufeDosis = roundUp(i / this.tageTitrierungInput) - 1;

            if (this.artDerDorierungInput == this.KolbenpipetteValue) {
                maxDosierungsart = round(this.maximaleTageDosisTHCInput / this.productTHC * (1 / this.KolbenpipetteValue)) / (1 / this.KolbenpipetteValue) / this.KolbenpipetteValue;
            } else {
                maxDosierungsart = round(this.maximaleTageDosisTHCInput / this.productTHC * (1 / this.DosierpumpeValue)) / (1 / this.DosierpumpeValue) / this.DosierpumpeValue;
            }

            var kolbDois = round(this.startTageDosisInput / this.productTHC * (1 / this.KolbenpipetteValue)) / (1 / this.KolbenpipetteValue) / this.KolbenpipetteValue + stufeDosis * round(this.steigerungDosisInput / this.productTHC * (1 / this.KolbenpipetteValue)) / (1 / this.KolbenpipetteValue) / this.KolbenpipetteValue;
            var hubDois = round(this.startTageDosisInput / this.productTHC * (1 / this.DosierpumpeValue)) / (1 / this.DosierpumpeValue) / this.DosierpumpeValue + stufeDosis * round(this.steigerungDosisInput / this.productTHC * (1 / this.DosierpumpeValue)) / (1 / this.DosierpumpeValue) / this.DosierpumpeValue;

            if (this.artDerDorierungInput == this.KolbenpipetteValue) {
                dosierungsart = kolbDois;
            } else {
                dosierungsart = hubDois;
            }
            if (dosierungsart < maxDosierungsart) {
                if (this.artDerDorierungInput == this.KolbenpipetteValue) {
                    dosierungsart = kolbDois;
                } else {
                    dosierungsart = hubDois;
                }
            } else {
                dosierungsart = maxDosierungsart;
            }

            summe += dosierungsart;
            summenML = summe * ((this.artDerDorierungInput == this.KolbenpipetteValue) ? this.KolbenpipetteValue : this.DosierpumpeValue);

            unterMenge = summenML < parseFloat(this.verschreibungsmengeInput) ? "x" : "";

            if (unterMenge == "x") {
                if (stufeDosis < this.oneStufeBis) {
                    morgens = round(dosierungsart * this.zeitlicherSchwerpunkt.stufe.one.morgensPer / 100);
                    mittags = round(dosierungsart * this.zeitlicherSchwerpunkt.stufe.one.mittagsPer / 100);
                    abends = round(dosierungsart * this.zeitlicherSchwerpunkt.stufe.one.abendsPer / 100);
                    zurnacht = round(dosierungsart * this.zeitlicherSchwerpunkt.stufe.one.zurNachtPer / 100);
                } else if (stufeDosis < this.twoStufeBis) {
                    morgens = round(dosierungsart * this.zeitlicherSchwerpunkt.stufe.two.morgensPer / 100);
                    mittags = round(dosierungsart * this.zeitlicherSchwerpunkt.stufe.two.mittagsPer / 100);
                    abends = round(dosierungsart * this.zeitlicherSchwerpunkt.stufe.two.abendsPer / 100);
                    zurnacht = round(dosierungsart * this.zeitlicherSchwerpunkt.stufe.two.zurNachtPer / 100);
                } else if (stufeDosis < this.threeStufeBis) {
                    morgens = round(dosierungsart * this.zeitlicherSchwerpunkt.stufe.three.morgensPer / 100);
                    mittags = round(dosierungsart * this.zeitlicherSchwerpunkt.stufe.three.mittagsPer / 100);
                    abends = round(dosierungsart * this.zeitlicherSchwerpunkt.stufe.three.abendsPer / 100);
                    zurnacht = round(dosierungsart * this.zeitlicherSchwerpunkt.stufe.three.zurNachtPer / 100);
                } else {
                    morgens = round(dosierungsart * this.zeitlicherSchwerpunkt.stufe.four.morgensPer / 100);
                    mittags = round(dosierungsart * this.zeitlicherSchwerpunkt.stufe.four.mittagsPer / 100);
                    abends = round(dosierungsart * this.zeitlicherSchwerpunkt.stufe.four.abendsPer / 100);
                    zurnacht = round(dosierungsart * this.zeitlicherSchwerpunkt.stufe.four.zurNachtPer / 100);
                }

                if (this.artDerDorierungInput == this.KolbenpipetteValue) {
                    morgens = morgens ? morgens * this.KolbenpipetteValue : 0;
                    mittags = mittags ? mittags * this.KolbenpipetteValue : 0;
                    abends = abends ? abends * this.KolbenpipetteValue : 0;
                    zurnacht = zurnacht ? zurnacht * this.KolbenpipetteValue : 0;
                }

                if (morgens) {
                    if (this.artDerDorierungInput == this.KolbenpipetteValue) {
                        morgensText = formatNumber(morgens, DE) + " mL";
                    } else {
                        morgensText = formatNumber(morgens, DE) + " Hübe";
                    }
                }
                if (mittags) {
                    if (this.artDerDorierungInput == this.KolbenpipetteValue) {
                        mittagsText = formatNumber(mittags, DE) + " mL";
                    } else {
                        mittagsText = formatNumber(mittags, DE) + " Hübe";
                    }
                }
                if (abends) {
                    if (this.artDerDorierungInput == this.KolbenpipetteValue) {
                        abendsText = formatNumber(abends, DE) + " mL";
                    } else {
                        abendsText = formatNumber(abends, DE) + " Hübe";
                    }
                }
                if (zurnacht) {
                    if (this.artDerDorierungInput == this.KolbenpipetteValue) {
                        zurnachtText = formatNumber(zurnacht, DE) + " mL";
                    } else {
                        zurnachtText = formatNumber(zurnacht, DE) + " Hübe";
                    }
                }
                thcd = morgens + mittags + abends + zurnacht;
                if (this.artDerDorierungInput == this.DosierpumpeValue) {
                    thcd = thcd * this.DosierpumpeValue;
                }
                thcd = formatNumber(round(thcd * this.productTHC, 1), DE) + " mg";
            }
            var werteObj = { tag: i, stufeDosis, maxDosierungsart, dosierungsart, morgens, mittags, abends, zurnacht, summenML, summe, unterMenge, morgensText, mittagsText, abendsText, zurnachtText, thcd };
            this.werteFurDiagrammList.push(werteObj);
        }
    }

    //Tilray Related
    fnCalculateWerteFurDiagrammTilRay() {
        this.werteFurDiagrammList = [];

        var tsStartDosis = [];
        var tsSterigerungsDosis = [];
        for (var i = 1; i <= 30; i++) {
            tsStartDosis.push({ level: i, morgens: 0, mittags: 0, abends: 1, zurnacht: 0 });
        };
        tsSterigerungsDosis.push({ level: 1, morgens: 0, mittags: 0, abends: 0, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 2, morgens: 0, mittags: 0, abends: 1, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 3, morgens: 1, mittags: 0, abends: 1, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 4, morgens: 2, mittags: 0, abends: 1, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 5, morgens: 2, mittags: 0, abends: 2, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 6, morgens: 3, mittags: 0, abends: 2, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 7, morgens: 3, mittags: 0, abends: 3, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 8, morgens: 4, mittags: 0, abends: 3, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 9, morgens: 4, mittags: 0, abends: 4, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 10, morgens: 5, mittags: 0, abends: 4, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 11, morgens: 5, mittags: 0, abends: 5, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 12, morgens: 6, mittags: 0, abends: 5, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 13, morgens: 6, mittags: 0, abends: 6, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 14, morgens: 7, mittags: 0, abends: 6, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 15, morgens: 7, mittags: 0, abends: 7, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 16, morgens: 8, mittags: 0, abends: 7, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 17, morgens: 8, mittags: 0, abends: 8, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 18, morgens: 9, mittags: 0, abends: 8, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 19, morgens: 9, mittags: 0, abends: 9, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 20, morgens: 10, mittags: 0, abends: 9, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 21, morgens: 10, mittags: 0, abends: 10, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 22, morgens: 11, mittags: 0, abends: 10, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 23, morgens: 11, mittags: 0, abends: 11, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 24, morgens: 12, mittags: 0, abends: 11, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 25, morgens: 12, mittags: 0, abends: 12, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 26, morgens: 13, mittags: 0, abends: 12, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 27, morgens: 13, mittags: 0, abends: 13, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 28, morgens: 14, mittags: 0, abends: 13, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 29, morgens: 14, mittags: 0, abends: 14, zurnacht: 0 });
        tsSterigerungsDosis.push({ level: 30, morgens: 15, mittags: 0, abends: 14, zurnacht: 0 });

        var summe = 0;
        var stufeDosis = 1;
        var umreDast = this.artDDorierungInput === this.KolbenpipetteValue ? this.KolbenpipetteValue : 1;

        for (var i = 1; i <= 200; i++) {
            var milligram = 0;
            var theorTHCTagesDosis = 0;
            var unterMaximalDosis = "";
            var dosierungsart = 0;
            var summenML = 0;
            var unterMenge = "";

            var morgens = 0;
            var mittags = 0;
            var abends = 0;
            var zurnacht = 0;

            var morgensText = "";
            var mittagsText = "";
            var abendsText = "";
            var zurnachtText = "";
            var thcd: any = "";

            milligram = roundUp(i / this.tageTitrierungInput);

            var basisCond = round(this.startTageDosisInput / this.productTHC * (1 / this.artDDorierungInput)) / (1 / this.artDDorierungInput) / this.artDDorierungInput + (roundUp(i / this.tageTitrierungInput) - 1) * round(this.steigerungDosisInput / this.productTHC * (1 / this.artDDorierungInput)) / (1 / this.artDDorierungInput) / this.artDDorierungInput;
            var theorTHCTagesDosis = basisCond * this.productTHC * this.artDDorierungInput;

            unterMaximalDosis = theorTHCTagesDosis < (this.maxDosierungsart + this.toleranzLimitMgThcD) ? "x" : "";
            stufeDosis = unterMaximalDosis == "x" ? roundUp(i / this.tageTitrierungInput) : stufeDosis;

            var basisCodn1 = round(this.maxDosierungsart / this.productTHC * (1 / this.artDDorierungInput)) / (1 / this.artDDorierungInput) / this.artDDorierungInput;
            dosierungsart = round(basisCond < basisCodn1 ? basisCond : basisCodn1);

            summe += dosierungsart;
            summenML = round(summe * this.artDDorierungInput, 2);
            unterMenge = summenML < parseFloat(this.verschreibungsmengeInput) ? "x" : "";

            if (unterMenge == "x") {
                var tsdObj = tsStartDosis.find(a => a.level == stufeDosis);
                var tsgdObj = tsSterigerungsDosis.find(a => a.level == stufeDosis);

                var morg = round(((tsdObj.morgens * this.startdosisIBE) + (tsgdObj.morgens * this.steigerungIBE)) * umreDast, 2);
                var mit = round(((tsdObj.mittags * this.startdosisIBE) + (tsgdObj.mittags * this.steigerungIBE)) * umreDast, 2);
                var abend = round(((tsdObj.abends * this.startdosisIBE) + (tsgdObj.abends * this.steigerungIBE)) * umreDast, 2);
                var zurna = round(((tsdObj.zurnacht * this.startdosisIBE) + (tsgdObj.zurnacht * this.steigerungIBE)) * umreDast, 2);

                if (morg) {
                    morgens = morg;
                    if (this.artDerDorierungInput == this.KolbenpipetteValue) {
                        morgensText = formatNumber(morgens, DE) + " mL";
                    } else {
                        morgensText = formatNumber(morgens, DE) + " Hübe";
                    }
                }
                if (mit) {
                    mittags = mit;
                    if (this.artDerDorierungInput == this.KolbenpipetteValue) {
                        mittagsText = formatNumber(mittags, DE) + " mL";
                    } else {
                        mittagsText = formatNumber(mittags, DE) + " Hübe";
                    }
                }
                if (abend) {
                    abends = abend;
                    if (this.artDerDorierungInput == this.KolbenpipetteValue) {
                        abendsText = formatNumber(abends, DE) + " mL";
                    } else {
                        abendsText = formatNumber(abends, DE) + " Hübe";
                    }
                }
                if (zurna) {
                    zurnacht = zurna;
                    if (this.artDerDorierungInput == this.KolbenpipetteValue) {
                        zurnachtText = formatNumber(zurnacht, DE) + " mL";
                    } else {
                        zurnachtText = formatNumber(zurnacht, DE) + " Hübe";
                    }
                }

                thcd = morgens + mittags + abends + zurnacht;
                thcd = round(thcd * this.productTHC, 1);
                thcd = formatNumber(thcd, DE) + " mg";
            }
            let werteObj = { tag: i, milligram, theorTHCTagesDosis, dosierungsart, unterMaximalDosis, stufeDosis, morgens, mittags, abends, zurnacht, summenML, summe, unterMenge, morgensText, mittagsText, abendsText, zurnachtText, thcd };
            this.werteFurDiagrammList.push(werteObj);
        }
    }


    //IBE= In Basis Einheite
    get startdosisIBE() {
        return round(this.startTageDosisInput / this.productTHC * (1 / this.artDDorierungInput));
    }

    get steigerungIBE() {
        return round(this.steigerungDosisInput / this.productTHC * (1 / this.artDDorierungInput));
    }

    get anzalTagTherapieplan() {
        return 30;
    }

    get summeEinheiteIn30D() {
        let obj = this.werteFurDiagrammList.find(a => a.tag == this.anzalTagTherapieplan + 1);
        return obj ? obj.summe : 0;
    }

    get summeMilliliterIn30D() {
        return this.artDDorierungInput * this.summeEinheiteIn30D;
    }

    get summeMilligramIn30D() {
        return this.summeMilliliterIn30D * this.productTHC;
    }

    get begrenzungMaxThcD() {
        return this.maxDosierungsart;
    }

    get toleranzLimitMgThcD() {
        return 1.1;
    }

    get begrenzungEinheite() {
        return this.maxDosierungsart / (this.artDDorierungInput * this.productTHC)
    }

    get einEinheiteHatMgTHC() {
        return this.artDDorierungInput * this.productTHC;
    }

    get einEinheiteHatMilliliter() {
        return this.artDDorierungInput;
    }

    get konzentrationTHCMGML() {
        return this.productTHC;
    }

    get tageRezept() {
        return this.werteFurDiagrammList.filter(a => a.unterMenge == "x").length;
    }

    get werteFurDiagrammListForTotalTag() {
        return this.werteFurDiagrammList.slice(0, this.totalTage);
    }

    chartTimer: any;
    fnGenerateChart() {
        clearTimeout(this.chartTimer);
        this.chartTimer = setTimeout(() => {
            d3.select("#titrationsPlanChart").selectAll("svg").remove();
            this.fnGeneratePlanChart();
        })
    }

    fnGeneratePlanChart() {
        var elmId = "titrationsPlanChart";
        var data = [];
        this.werteFurDiagrammListForTotalTag.forEach(item => {
            var obj = {
                tag: item.tag,
                morgens: item.morgens,
                mittags: item.mittags,
                abends: item.abends,
                zurnacht: item.zurnacht
            }
            data.push(obj);
        })
        var title = `Titrationsplan für die Dosierung in ${(this.artDerDorierungInput == this.KolbenpipetteValue) ? 'Millilitern' : 'Hüben'}`;
        var yText = (this.artDerDorierungInput == this.KolbenpipetteValue) ? 'Milliliter' : 'Hübe';
        this.generateChartDiagram(elmId, data, title, yText);
    }

    generateChartDiagram(elmId, data, title, yText) {
        var tags = data.map(a => a.tag);
        var groups = ["morgens", "mittags", "abends", "zurnacht"];
        var labels = [
            { key: 'morgens', label: 'morgens' },
            { key: 'mittags', label: 'mittags' },
            { key: 'abends', label: 'abends' },
            { key: 'zurnacht', label: 'zur Nacht' }
        ];
        var colorRange = ['#4a86e8', '#f6b81b', '#cc4125', '#351c75'];
        switch (this.partnerName) {
            case PartnerNamesEnum.DOSIS_EQ_TILRAY:
                groups = ["morgens", "abends"];
                labels = [
                    { key: 'morgens', label: 'Morgens' },
                    { key: 'abends', label: 'Abends' }
                ];
                colorRange = ['#5da2f4', '#0051ce'];
                break;
            case PartnerNamesEnum.DOSIS_EQ_420_PHARMA:
                colorRange = ['#B4C94A', '#889B23', '#5F9D0A', '#0E2E1D'];
                break;
            default:
                break;
        }
        if (this.partnerName === PartnerNamesEnum.DOSIS_EQ_TILRAY) {

        }

        const stackedData = d3.stack().keys(groups)(data);

        // set the dimensions and margins of the graph
        var elmWidth = document.getElementById(elmId).clientWidth;
        var elmHeight = 420;

        var maxTotal = 0;
        data.forEach(a => {
            var total = 0;
            groups.forEach(g => {
                total += a[g];
            })
            if (maxTotal < total) {
                maxTotal = total;
            }
        })

        var margin = { top: 40, right: 10, bottom: 50, left: 50 },
            width = elmWidth - margin.left - margin.right,
            height = elmHeight - margin.top - margin.bottom;

        // append the svg object to the body of the page
        var svg = d3.select(`#${elmId}`)
            .append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform",
                "translate(" + margin.left + "," + margin.top + ")");

        // Add X axis
        var x = d3.scaleBand()
            .domain(tags)
            .range([0, width])
            .padding(0.2)

        svg.append("g")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom(x).tickSizeOuter(0));

        // Add Y axis
        var y = d3.scaleLinear()
            .domain([0, roundUp(maxTotal, 1)])
            .range([height, 0]);

        svg.append("g")
            .call(
                d3.axisLeft(y)
                    .tickFormat((value, i) => {
                        return `${formatNumber(Number(value), DE)}`
                    })
            );

        // color palette = one color per group
        var color = d3.scaleOrdinal()
            .domain(groups)
            .range(colorRange)

        // now add titles to the axes
        svg.append('g')
            .append("text")
            .style("font-size", "18px")
            .attr("transform", "translate(-40,-25)")  // top left corner
            .attr("font-weight", "500")
            .text(title);

        svg.append('g')
            .append("text")
            .style("font-size", "14px")
            .attr("text-anchor", "middle")  // this makes it easy to centre the text as the transform is applied to the anchor
            .attr("transform", "translate(15," + (height + 30) + ")")  // centre below axis
            .text("Tag");

        svg.append('g')
            .append("text")
            .style("font-size", "14px")
            .attr("text-anchor", "middle")  // this makes it easy to centre the text as the transform is applied to the anchor
            .attr("transform", "translate(" + -30 + "," + (height - 20) + ")rotate(-90)")  // text is drawn off the screen top left, move down and out and rotate
            .text(yText);


        var legend = svg.append("g")
            .attr("class", "svg-legend")
            .attr("font-size", 12)
            .attr("transform", "translate(" + (elmWidth - (90 * groups.length)) + "," + (height + 35) + ")")
            .selectAll("g")
            .data(groups.slice())
            .enter().append("g")
            .attr("transform", function (d, i) {
                return "translate(" + i * 75 + ",0)";
            });

        legend.append("rect")
            .attr("y", 0)
            .attr("width", 12)
            .attr("height", 12)
            .attr("fill", function (d: any) { return color(d).toString(); });

        legend.append("text")
            .attr("x", 15)
            .attr("y", 6)
            .attr("dy", "0.35em")
            .text(function (d) {
                return labels.find(a => a.key == d).label;
            });


        // Show the bars
        svg.append("g")
            .selectAll("g")
            // Enter in the stack data = loop key per key = group per group
            .data(stackedData)
            .enter().append("g")
            .attr("fill", function (d) { return color(d.key).toString(); })
            .selectAll("rect")
            // enter a second time = loop groups per groups to add all rectangles
            .data(function (d: any) { return d; })
            .enter().append("rect")
            .attr("x", function (d: any) { return x(d.data.tag); })
            .attr("y", function (d: any) { return y(d[1]); })
            .attr("height", function (d: any) { return y(d[0]) - y(d[1]); })
            .attr("width", x.bandwidth())

        svg.append("g")
            .selectAll("g")
            // Enter in the stack data = loop key per key = group per group
            .data(stackedData)
            .enter().append("g")
            .selectAll("text")
            // enter a second time = loop groups per groups to add all rectangles
            .data(function (d: any) { return d; })
            .enter().append("text")
            .attr("x", function (d: any) { return x(d.data.tag); })
            .attr("y", function (d: any) { return y(d[1]); })
            .attr("dx", x.bandwidth() / 2)
            .attr("dy", function (d: any) { return (y(d[0]) - y(d[1])) / 2; })
            .attr("font-size", 10)
            .attr("text-anchor", "middle")
            .attr("fill", "#ffffff")
            .attr("pointer-events", "none")
            .text(function (d) {
                var diff = d[1] - d[0];
                return diff > 0 ? formatNumber(round(diff, 2), DE) : "";
            })

    }

    @HostListener('window:resize', ['$event'])
    fnOnResizeWindow(event) {
        this.fnGenerateChart();
    }
}
